import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import Grid from "@material-ui/core/Grid"
import { useSnackbar } from "notistack"

import { API } from "aws-amplify" //, graphqlOperation
import { listDocuments } from "../graphqlCustom/queries"

import Accordions from "../components/Accordions"

const documentsItems = [
  {
    addTime: "timeMinutes",
    key: "sendMinutes",
    title: "Meeting Minutes",
    type: "MEETING",
  },
  {
    addTime: "timeBudgets",
    key: "sendBudgets",
    title: "Budgets",
    type: "BUDGET",
  },
  {
    key: "sendFinancials",
    title: "Financial",
    type: "FINANCIAL",
  },
  {
    key: "sendBylaws",
    title: "Bylaws & Declarations",
    type: "BYLAW",
  },
  {
    key: "sendRules",
    title: "Rules & Regulations",
    type: "RULE",
  },
]

const times = [
  {
    label: "Past Year",
    value: 1,
  },
  {
    default: true,
    label: "Past 2 Years",
    value: 2,
  },
  {
    label: "Past 3 Years",
    value: 3,
  },
  {
    label: "Past 4 Years",
    value: 4,
  },
  {
    label: "All",
    value: "all",
  },
]

const translateTime = (time) => {
  for (let i = 0, l = times.length; i < l; i++) {
    if (time === times[i].value) {
      return times[i].label
    }
  }
  return null
}

const initialState = {
  documents: {
    BUDGET: [],
    BYLAW: [],
    FINANCIAL: [],
    MEETING: [],
    RULE: [],
  },
}
const reducer = (state, action) => {
  switch (action.type) {
    case "ADD_DOCUMENTS":
      return { ...state, documents: { ...state.documents, [action.docType]: action.documents } }
    default:
      return state
  }
}

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(5),
  },
  blankWrapper: {
    width: "100%",
  },
}))

const ViewShareDocuments = ({ sendData }) => {
  const classes = useStyles()
  const [state, dispatch] = React.useReducer(reducer, initialState)
  const { enqueueSnackbar } = useSnackbar()

  React.useEffect(() => {
    async function fetchDocuments(documentsType) {
      try {
        // const documents = await API.graphql(
        //   graphqlOperation(listDocuments, {
        //     limit: 200,
        //     sortDirection: "DESC",
        //     associationId: sendData.association.id,
        //     typeCreatedAt: {
        //       beginsWith: {
        //         type: documentsType,
        //       },
        //     },
        //   })
        const documents = await API.graphql({
          authMode: "AWS_IAM",
          query: listDocuments,
          variables: {
            limit: 200,
            sortDirection: "DESC",
            associationId: sendData.association.id,
            typeCreatedAt: {
              beginsWith: {
                type: documentsType,
              },
            },
          },
        })
        dispatch({
          type: "ADD_DOCUMENTS",
          docType: documentsType,
          documents: documents.data.listDocuments.items,
        })
      } catch (error) {
        console.log("error", error)
        enqueueSnackbar("Error fetching documents", {
          variant: "error",
        })
      }
    }
    async function getAllDocuments() {
      for (let i = 0, l = documentsItems.length; i < l; i++) {
        if (sendData.fields[documentsItems[i].key]) {
          await fetchDocuments(documentsItems[i].type)
        }
      }
    }
    getAllDocuments()
  }, [sendData, enqueueSnackbar])

  return (
    <Grid className={classes.root} container spacing={3}>
      {documentsItems.map((documentsItem) => (
        <div className={classes.blankWrapper} key={documentsItem.key}>
          {sendData.fields[documentsItem.key] ? (
            <Grid item xs={12}>
              {state.documents[documentsItem.type] && state.documents[documentsItem.type].length ? (
                <>
                  <h3>
                    {documentsItem.title}
                    {documentsItem.addTime &&
                    sendData.fields[documentsItem.key.replace("send", "time")]
                      ? ": " +
                        translateTime(sendData.fields[documentsItem.key.replace("send", "time")])
                      : ""}
                  </h3>
                  <Accordions items={state.documents[documentsItem.type]} />
                </>
              ) : (
                ""
              )}
            </Grid>
          ) : (
            ""
          )}
        </div>
      ))}
    </Grid>
  )
}

export default ViewShareDocuments
